import React from 'react';
import { useTranslation } from 'react-i18next';

// Shown only when the vehicle has a recent crash event. Independent of device
// online/offline state, so a crash that knocked the device offline still alerts.
export default function CrashAlertCard({ crashes }) {
  const { t } = useTranslation();
  if (!crashes || crashes.length === 0) return null;

  const c = crashes[0];
  const when = new Date(c.occurredAt).toLocaleString('fr-FR');
  const zone = c.sector
    ? t(`ownerTelematics.crashAlert.sectors.${c.sector}`)
    : t('ownerTelematics.crashAlert.undetermined');

  return (
    <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4">
      <div className="flex items-start gap-2">
        <span className="text-xl leading-none">⚠️</span>
        <div>
          <p className="text-sm font-semibold text-red-700">
            {t('ownerTelematics.crashAlert.title')}
            {c.simulated && (
              <span className="ml-2 rounded-full bg-gray-200 px-2 py-0.5 align-middle text-xs font-normal text-gray-600">
                {t('ownerTelematics.crashAlert.simulation')}
              </span>
            )}
          </p>
          <p className="text-sm text-red-700">{t('ownerTelematics.crashAlert.detectedAt')} {when}</p>
          <p className="mt-1 text-sm text-red-700">
            {t('ownerTelematics.crashAlert.probableZone')} : <span className="font-semibold">{zone}</span>
            {c.sector && c.confidence != null && <span> · {c.confidence}%</span>}
          </p>
          {c.severity && (
            <span className="mt-1 inline-block rounded-full bg-red-100 px-2 py-0.5 text-xs text-red-700">
              {t(`ownerTelematics.crashAlert.severity.${c.severity}`)}
            </span>
          )}
          {crashes.length > 1 && (
            <p className="mt-1 text-xs text-red-500">
              {t('ownerTelematics.crashAlert.more', { count: crashes.length - 1 })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
